// Mirrors @lotngo/shared's LEVELS array (imported directly here since web,
// unlike the API, bundles @lotngo/shared as real runtime values via Vite —
// see the comment in shared/src/constants/index.ts for why the API can't).
// Icons live here rather than in shared since they're a pure web/UI concern.
import { LEVELS as SHARED_LEVELS } from '@lotngo/shared';

export const MAX_LEVEL = 10;

const LEVEL_ICONS: Record<string, string> = {
  registered:         'local_parking',
  first_share:        'bolt',
  regular:            'event_repeat',
  responder:          'volunteer_activism',
  hands_free_sharer:  'my_location',
  flexible_neighbor:  'schedule_send',
  multi_spot_host:    'directions_car',
  trusted_sharer:     'military_tech',
  go_to_neighbor:     'handshake',
  community_pillar:   'workspace_premium',
};

export interface LevelDef {
  level: number;
  key: string;
  icon: string;
  titleKey: string;
  descKey: string;
}

export const LEVEL_DEFS: LevelDef[] = SHARED_LEVELS.map((l) => ({
  level: l.level,
  key: l.key,
  icon: LEVEL_ICONS[l.key],
  titleKey: `level_${l.key}_title`,
  descKey: `level_${l.key}_desc`,
}));

export function getLevelDef(level: number): LevelDef | undefined {
  return LEVEL_DEFS.find((l) => l.level === level);
}
